import { css } from 'aphrodite';
import { Controller, useFormContext } from 'react-hook-form';
import { ICustomSurvey, IRichContentEditorState } from '../../../../../extViewmodels';
import { ToolbarCustomSurvey } from '../../../../../models/UiUtils';
import {
	IRichContentDocumentEditorConfig,
	RichContentDocumentEditor,
} from '../../../../components/richContent/RichContentDocumentEditor';
import { usePreviewMode } from '../../shared/contexts/PreviewModeContext';
import { styleSheet } from '../styles';
import { NotificationOptions } from './NotificationOptions';

const config: IRichContentDocumentEditorConfig = {
	plugins: 'autolink',
	toolbar: ToolbarCustomSurvey,
};

export const ConfirmationSettings = ({ survey }: { survey: ICustomSurvey }) => {
	const { control, watch } = useFormContext<ICustomSurvey>();
	const { isPreviewOnly } = usePreviewMode();
	const formValues = watch();

	return (
		<section className={css(styleSheet.tabsControllerWrap)}>
			<h3>Confirmation</h3>
			<div className={css(styleSheet.formControl)}>
				<label htmlFor='confirmationMessage'>Confirmation Message</label>
				<Controller
					name='options.confirmationMessage'
					control={control}
					render={({ field: { ref, ...fieldProps } }) => (
						<RichContentDocumentEditor
							className={css(styleSheet.editor)}
							config={config}
							contentState={formValues?.options?.confirmationMessage as IRichContentEditorState}
							onContentStateChanged={fieldProps.onChange}
							readOnly={isPreviewOnly}
							readOnlyUseFullEditor={true}
						/>
					)}
				/>
			</div>
			<NotificationOptions survey={survey} />
		</section>
	);
};
